import styled from 'styled-components';

export const CarouselWrapperStyled = styled.div`
    .carousel .control-dots {
        width: unset;
        ${({ dotsLeftOffset }) => dotsLeftOffset && 'margin-left: ' + dotsLeftOffset + ';'};
        ${({ centerDots }) => centerDots && 'width: 100%; margin-left: 0;'};
        margin-bottom: 5px;

        .dot {
            box-shadow: none;
            opacity: 1;
            background: var(--color-purple-highlight);
            margin: 0 12px;
            width: 14px;
            height: 14px;

            &.selected {
                background: var(--color-yellow);
            }

            &:hover:not(.selected) {
                background: var(--color-white);
            }
        }
    }
`;

export const ControlIconWrapper = styled.div`
    display: inline-block;
    bottom: 0;
    ${({ prev }) => (prev ? 'left: 0;' : 'right: 0;')}
    position: absolute;
    z-index: 2;

    ${({ hasNext }) => (hasNext ? 'cursor: pointer;' : '')}
    svg {
        fill: var(${({ hasNext }) => (hasNext ? '--color-yellow' : '--color-purple-highlight')});

        &:hover {
            ${({ hasNext }) => (hasNext ? 'fill: var(--color-yellow-light);' : '')}
        }
    }
`;
